import { useRef } from "react";

export const MAX_LINES = 40;
export const MAX_CHARS = 3000;
export const noteLines = (v) => v.split("\n").map((x) => x.trim()).filter(Boolean);
export const numbered = (v) => noteLines(v).map((x, i) => `${i + 1}. ${x}`).join("\n");

export default function BFNotes({ value, onChange }) {
  const gutter = useRef(null);
  const raw = value.split("\n");
  const rows = Math.max(4, raw.length);
  let k = 0;
  const nums = Array.from({ length: rows }, (_, i) => (i >= raw.length || raw[i].trim() || (i === raw.length - 1) ? `${++k}.` : "\u00a0"));
  const set = (e) => onChange(e.target.value.split("\n").slice(0, MAX_LINES).join("\n").slice(0, MAX_CHARS));
  return (
    <div className="bf-notes" data-testid="bf-notes">
      <label htmlFor="bf-notes-input">Observații (opțional)</label>
      <p className="bf-notes-hint">Nu găsești un cod? Scrie aici ce produs vrei sau alte detalii. Câte un lucru pe rând, apasă Enter pentru rândul următor.</p>
      <div className="bf-notes-box">
        <div ref={gutter} className="bf-notes-gutter" aria-hidden="true">
          {nums.map((n, i) => <span key={i}>{n}</span>)}
        </div>
        <textarea id="bf-notes-input" rows={rows} value={value} onChange={set} onScroll={(e) => { gutter.current.scrollTop = e.target.scrollTop; }}
          placeholder={"ex: Șampon Nutrisubstance 1000 ml, 2 buc.\nVopsea 7.1 nu am găsit codul"} data-testid="bf-notes-input" />
      </div>
      <small className="bf-notes-count" data-testid="bf-notes-count">{noteLines(value).length} / {MAX_LINES} rânduri · {value.length} / {MAX_CHARS} caractere</small>
    </div>
  );
}
